module.exports = __webpack_public_path__ + "7530bb42ef023d868e28825aee2c1d7c.png";